<div class="header main-app">
    <div class="avatar">
        <core-avatar-img [user]="user" [size]="40"> </core-avatar-img>
    </div>
    <div class="info">
        <p>
            <span class="author-pre" [innerHTML]="preText">{{preText}}</span>
            <span class="author-name">{{user.name}}</span>
            <span class="author-feedback" *ngIf="feedback != null">
                <core-helpers-icons-colored-bubble-circle-letter
                    [title]="feedback.user.name"
                    [color]="getBubbleColor(feedback)"
                ></core-helpers-icons-colored-bubble-circle-letter>
            </span>
            <!-- new dec-2023 in case we want bubbles in messages only for on type we could select-->
            <ng-container  *ngIf="versionShares != null">
                <span class="author-feedback" *ngFor="let versionShare of versionShares">
                    <core-helpers-icons-colored-bubble-circle-letter
                        [title]="versionShare.entry.user.name"
                        [color]="getVersionShareBubbleColor(versionShare)"
                    ></core-helpers-icons-colored-bubble-circle-letter>
                </span>
            </ng-container>
            <span class="author-pos"[innerHTML]="posText"> {{posText}}</span>
        </p>
        <p *ngIf="date != null"><span class="tw-message__txt">{{date | date:'dd MMM yyyy'}} at {{ date | date:'HH:mm'}}</span></p>
    </div>
</div>
